// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Intercom from "../externals/Intercom.res.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";

let ArticleID = {};

function install(appId) {
  Intercom.install(appId);
}

function setup(appId) {
  window.Intercom("boot", {
    app_id: appId,
    hide_default_launcher: true
  });
}

function updateUserFields(name, userId, email, param) {
  window.Intercom("update", {
    name: name,
    email: Stdlib_Nullable.fromOption(email),
    user_id: Stdlib_Nullable.fromOption(userId)
  });
}

function updateSessionUrl(sessionUrl) {
  if (sessionUrl !== "") {
    window.Intercom("update", {
      latestPosthogReplayURL: sessionUrl
    });
    return;
  }
}

function show() {
  window.Intercom("show");
}

function showArticle(id) {
  window.Intercom("showArticle", id);
}

function showHome() {
  window.Intercom("showSpace", "home");
}

function showHelp() {
  window.Intercom("showSpace", "help");
}

function showMessages() {
  window.Intercom("showSpace", "messages");
}

function openNewMessage(content) {
  window.Intercom("showNewMessage", content);
}

let howCentralizeCatalog = "8202106";

let prepareImportInventory = "8155377";

let verifyCashRegisterArchive = "10589291";

let automaticOrdering = "7068311";

let orderLabelSheets = "7118898";

let setupLabelPrinterAndStarPrinterOnline = "9113414";

let getLabelPrintFeature = "9204256";

let termsAndConditions = "8889741";

let setupAndExportAccountingEntries = "10244703";

let useAutomaticOrderFeature = "7068311";

let eInvoicingHowTo = "14612548";

let eInvoicingSetupEndpoint = "16783675";

let gettingStartedGuideLink = "https://quirky-amaranthus-c07.notion.site/Vos-premiers-pas-chez-Wino-9ea8719601494a748a4ee1a83a7d31b9";

export {
  ArticleID,
  howCentralizeCatalog,
  prepareImportInventory,
  verifyCashRegisterArchive,
  automaticOrdering,
  orderLabelSheets,
  setupLabelPrinterAndStarPrinterOnline,
  getLabelPrintFeature,
  termsAndConditions,
  setupAndExportAccountingEntries,
  useAutomaticOrderFeature,
  eInvoicingHowTo,
  eInvoicingSetupEndpoint,
  gettingStartedGuideLink,
  install,
  setup,
  updateUserFields,
  updateSessionUrl,
  show,
  showArticle,
  showHome,
  showHelp,
  showMessages,
  openNewMessage,
}
/* No side effect */
